import { bounds } from '../utils/index';
import { gsap, ScrollTrigger } from '../libraries/gsap/index';

export default class Sticky {
  constructor(obj) {
    const { el, sticky, isSmooth, onUpdateCallback } = obj;

    this.el = el;
    this.sticky = sticky;
    this.isSticky = false;
    this.isSmooth = isSmooth;
    this.progress = 0;
    this.total = 0;
    this.flag = false;
    this.positionX = 0;
    this.positionY = 0;
    this.scrollTrigger = null;
    this.onUpdateCallback = typeof onUpdateCallback === 'function' ? onUpdateCallback : null;

    this.config = {
      width: 0,
      height: 0,
      totalWidth: 0,
      totalHeight: 0,
      totalItems: 0,
    };
    if (!isSmooth) sticky.style.pointerEvents = 'none';
    this.init();
  }

  observer() {
    this.scrollTrigger = ScrollTrigger.create({
      trigger: this.el,
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      onEnter: () => this.toggleSticky(true),
      onEnterBack: () => this.toggleSticky(true),
      onLeave: () => this.toggleSticky(false, true), // ✅ Ensure totalHeight is passed
      onLeaveBack: () => this.toggleSticky(false),
      onUpdate: (self) => this.onUpdate(self),
      ease: 'none',
    });
  }

  toggleSticky(isSticky, hasTotalHeight = false) {
    this.isSticky = isSticky;
    isSticky ? this.addSticky() : this.removeSticky(hasTotalHeight ? this.config.totalHeight : 0);
  }

  addSticky() {
    if (!this.sticky || this.isSmooth) return;
    this.sticky.classList.add('-fixed');
    gsap.set(this.sticky, { top: 0, position: '' });
  }

  removeSticky(totalHeight = 0) {
    if (!this.sticky || this.isSmooth) return;
    this.sticky.classList.remove('-fixed');
    gsap.set(this.sticky, { top: `${totalHeight}px`, position: 'relative' });
  }

  onUpdate(self) {
    if (this.flag) return;

    const { totalWidth, totalHeight } = this.config;
    const newProgress = self.progress;
    const newY = newProgress * totalHeight;
    const newX = -newProgress * totalWidth;

    // Only update if values change to prevent unnecessary calls
    if (this.progress !== newProgress || this.positionY !== newY || this.positionX !== newX) {
      this.progress = newProgress;
      this.positionY = newY;
      this.positionX = newX;

      if (this.isSmooth) {
        gsap.set(this.sticky, { y: this.positionY });
      }

      // Call the callback function if provided
      if (this.onUpdateCallback) {
        this.onUpdateCallback({
          progress: this.progress,
          positionX: this.positionX,
          positionY: this.positionY,
        });
      }
    }
  }

  resize() {
    if (!this.sticky) return;
    // Get the viewport height dynamically instead of using store
    const vh = window.innerHeight;
    let stickyRect = bounds(this.el);
    let totalHeight = stickyRect.height - vh;
    this.config.totalHeight = stickyRect.height - vh;
  }

  destroy() {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill();
      this.scrollTrigger = null;
    }
    this.sticky = null;
    this.el = null;
  }

  init() {
    this.observer();
  }
}
